import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import VenmoIcon from '@/assets/icons/venmo';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { DepositStackParamList } from '@/navigation/types';

import { AddPaymentMethod } from './AddPaymentMethod';
import { PopularTag } from './PopularTag';

export const AddPaymentMethodVenmo = () => {
    const { t } = useTranslation('transactions');
    const { navigate } = useNavigation<NativeStackNavigationProp<DepositStackParamList>>();
    return (
        <AddPaymentMethod
            icon={<VenmoIcon />}
            title={t('venmo')}
            description={t('venmo_description')}
            onPress={() => navigate('VenmoDepositScreen', {})}
            tag={<PopularTag />}
            analyticsEvent={AnalyticsEvent.DEPOSIT_METHOD_VENMO}
        />
    );
};
